import type { TenantConfig } from './types';

export const fullTenant: TenantConfig = {
  variant: 'full',
  logoUrl: '/fashionai-logo.svg',
};
